// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import { getValue, getList } from '../../../utilities/workinfo';
import { titleCase, formatArtistName } from '../../../utilities/text';
import type { Props } from '.';
import LoadingModal from '../../modals/loading';
import PageHeader from '../../page-header';
import { ShareholderCard, MoreInfo } from '..';
import { PageHeaderTab } from '../../page-header/page-header';
import '../work.scss';

const ua = navigator.userAgent.toLowerCase();
const isAndroid = ua.indexOf('android') > -1; // && ua.indexOf("mobile");

class WorkInfo extends Component<Props> {
  props: Props;

  componentDidMount() {
    const { workDetails, searchParams } = this.props;
    workDetails(searchParams, false);
  }

  componentDidUpdate(prevProps) {
    const { user, searchParams, workDetails } = this.props;
    if (
      user &&
      prevProps.user &&
      (user.cae !== prevProps.user.cae ||
        prevProps.searchParams.pageNumber !==
        searchParams.pageNumber)
    ) {
      workDetails(searchParams);
    }
  }

  getListElements(list, fieldName) {
    return getList(list, fieldName).map(v => (
      <span key={v}>
        {v}
        <br />
      </span>
    ));
  }

  openShareholdersTab = () => {
    const { openWorksShareholdersTab } = this.props;
    openWorksShareholdersTab();
  }

  openmoreTab = () => {
    const { openWorksMoreInfoTab } = this.props;
    openWorksMoreInfoTab();
  }

  onShareButtonClick = () => {
    const { searchDetails } = this.props;
    const { allianceTunecode } = searchDetails;
    const registeredTitle = getValue(searchDetails.titles, 'Registered Title');
    const shareUrl = `https://apps.prsformusic.com/WACD/WorksSearch.aspx?Type=DetailWork&ButtonSubmit=true&SearchField=0006&WorkNumber=${allianceTunecode}`;
    const shareTitle = `PRS Work - "${registeredTitle}"`;

    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        text: 'Hey, I thought you might be interested in this PRS for Music work',
        url: shareUrl,
      }).then(() => console.log('Successful share')).catch(() => {
        // eslint-disable-next-line no-alert
        console.log('Webshare not supported');
      });
    } else if (isAndroid) {
      // eslint-disable-next-line no-restricted-globals
      location.href = `intent:#Intent;action=android.intent.action.SEND;type=text/plain;S.android.intent.extra.TEXT=${shareUrl};S.android.intent.extra.SUBJECT=${shareTitle};end`;
    } else {
      // eslint-disable-next-line no-alert
      console.log('Webshare not supported');
    }
  }

  renderMoreInfoElement(title, value) {
    return (
      <React.Fragment>
        <h4>{title}</h4>
        <p>
          {(value && value.length) ? value : '--'}
        </p>
      </React.Fragment>
    );
  }

  renderMoreTab() {
    const { searchDetails } = this.props;
    const registeredTitle = getValue(searchDetails.titles, 'Registered Title');
    const workStatus = getValue(searchDetails.status, 'Work Status');
    const prsPreviouslyDistributed = getValue(searchDetails.miscellaneous, 'PRS Last Distribution');
    const mcpsPreviouslyDistributed = getValue(searchDetails.miscellaneous, 'MCPS Last Distribution');
    const workAmendmentDate = getValue(searchDetails.dates, 'Work Amendment date');
    const workCreationDate = getValue(searchDetails.dates, 'Work Creation date');
    const iswcNumbers = this.getListElements(searchDetails.numbers, 'ISWC');
    const publisherWorkReferences = this.getListElements(searchDetails.numbers, 'Publisher work reference');
    return (
      <div className="container">
        <MoreInfo>
          {this.renderMoreInfoElement('Registered Title', titleCase(registeredTitle))}
          {this.renderMoreInfoElement('ISWC', iswcNumbers)}
          {this.renderMoreInfoElement('Work status', workStatus)}
          {this.renderMoreInfoElement('PRS last distribution', prsPreviouslyDistributed)}
          {this.renderMoreInfoElement('MCPS last distribution', mcpsPreviouslyDistributed)}
          {this.renderMoreInfoElement('Work Amendment date', workAmendmentDate)}
          {this.renderMoreInfoElement('Work Creation Date', workCreationDate)}
          {this.renderMoreInfoElement('Publisher Work Reference(s)', publisherWorkReferences)}
        </MoreInfo>
      </div>
    );
  }

  renderContent() {
    const {
      tuneCode,
      className,
      searchDetails,
      workShareList,
      membershipNo,
      backLinkTo,
      backLinkText,
      headerIcon,
      shareholdersTabOpen,
      moreTabOpen,
    } = this.props;
    let shareButtonClick = null;
    if (navigator.share || isAndroid) {
      shareButtonClick = this.onShareButtonClick;
    }
    const title = titleCase(getValue(searchDetails.titles, 'Registered Title'));
    return (
      <section className={classnames(
        'main-content',
        'd-flex',
        'flex-column',
        className,
      )}
      >
        <PageHeader
          title={title}
          tuneCode={tuneCode}
          iconClassName={headerIcon}
          membershipNo={membershipNo}
          backLinkTo={backLinkTo}
          backLinkText={backLinkText}
          onShareButtonClick={shareButtonClick}
          alignLeft
        >
          <PageHeaderTab onClick={this.openShareholdersTab} active={shareholdersTabOpen}>
            Shareholders
          </PageHeaderTab>
          <PageHeaderTab onClick={this.openmoreTab} active={moreTabOpen}>
            More
          </PageHeaderTab>
        </PageHeader>
        <div className="search-pane flex-grow-1">
          {shareholdersTabOpen && (
            workShareList
              .map(({
                ipRole,
                ipName,
                perfShare,
                mechShare,
                ipNameKey,
                caeNumber,
                chainOfTitle,
                perfSociety,
                mechSociety,
              }) => {
                const displayCaeNumber = (caeNumber && caeNumber.length) ? caeNumber : '--';
                return (
                  <ShareholderCard
                    key={ipNameKey}
                    caeNumber={caeNumber}
                    roleName={ipRole}
                    artistName={formatArtistName(ipName)}
                    performingShare={perfShare}
                    mechanicalShare={mechShare}
                  >
                    <h5>CAE Number</h5>
                    <p>{displayCaeNumber}</p>
                    <h5>Chain of title</h5>
                    <p>{(chainOfTitle && chainOfTitle.length) ? chainOfTitle : '--'}</p>
                    <h5>Current UK Performing Society</h5>
                    <p>{(perfSociety && perfSociety.length) ? perfSociety : '--'}</p>
                    <h5>Current UK Mechanical Society</h5>
                    <p>{(mechSociety && mechSociety.length) ? mechSociety : '--'}</p>
                  </ShareholderCard>
                );
              })
          )}
          {moreTabOpen && (
            this.renderMoreTab()
          )}
        </div>
      </section>
    );
  }

  render() {
    const { user, authenticating, fetching } = this.props;
    return user && !authenticating && !fetching ?
      this.renderContent() :
      <LoadingModal />;
  }
}

export default WorkInfo;
